import { getComposeEvent } from 'owa-calendar-compose-store-manager';
import type SingleRecipientType from 'owa-service/lib/contract/SingleRecipientType';

// Returns the organizer for the current event in the store
export default function getCurrentEventOrganizer(formId: string): SingleRecipientType {
    const composeEvent = getComposeEvent(formId);
    return composeEvent ? composeEvent.Organizer : null;
}
